var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TK_BOX"},[_c('div',{staticClass:"main",style:('width:' + "" + _vm.width + 'px')},[_c('p',{staticClass:"title"},[_c('span'),_vm._v(_vm._s(_vm.title || ""))]),_vm._v(" "),_c('div',{staticClass:"tk_main"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55de53f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popupBox.vue
// module id = vUd3
// module chunks = 1